import "overlayscrollbars/overlayscrollbars.css";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "./ScrollableContainer.css";

const ScrollableContainer = ({ children }: { children: React.ReactNode }) => {
    return (
        <OverlayScrollbarsComponent
            className="scrollable-container"
            options={{
                scrollbars: {
                    theme: "os-theme-dark",
                    visibility: "auto",
                    autoHide: "move",
                    autoHideDelay: 800,
                },
            }}
        >
            {children}
        </OverlayScrollbarsComponent>
    );
};

export default ScrollableContainer;